import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import DiscussionList from 'flarum/forum/components/DiscussionList';
app.initializers.add('val-ui-child-forums', () => {
  const VAL_WELCOME_PARENT_TAG_ID = '4';
  const VAL_WELCOME_DISCUSSION_ID = '11323';
  const valTreeTagsByParent = new Map();
  const valTreeTagsLoaded = new Set();
  const valTreeTagsLoading = new Set();
  const valTreeTagsRetryCount = new Map();
  const valLoadTreeTags = function (parentTag) {
    if (!parentTag || typeof parentTag.id !== "function" || !app.forum || typeof app.forum.attribute !== "function" || typeof app.request !== "function") {
      return;
    }
    const id = String(parentTag.id());
    if (!id || valTreeTagsLoaded.has(id) || valTreeTagsLoading.has(id)) {
      return;
    }
    valTreeTagsLoading.add(id);
    app.request({
      method: "GET",
      url: app.forum.attribute("apiUrl") + "/val/ui/tree-tags?parent=" + encodeURIComponent(id)
    }).then(function (result) {
      valTreeTagsByParent.set(id, result && Array.isArray(result.tags) ? result.tags : []);
      valTreeTagsLoaded.add(id);
      valTreeTagsLoading.delete(id);
      valTreeTagsRetryCount.delete(id);
      m.redraw();
      valScheduleChildForums();
    }).catch(function () {
      valTreeTagsLoading.delete(id);
      const retries = valTreeTagsRetryCount.get(id) || 0;
      if (retries < 5) {
        valTreeTagsRetryCount.set(id, retries + 1);
        window.setTimeout(function () {
          valLoadTreeTags(parentTag);
        }, 1000);
      }
    });
  };
  const valCurrentTag = function () {
    if (!app.store || typeof app.store.all !== "function") {
      return null;
    }
    let slug = null;
    try {
      slug = m.route.param("tags");
    } catch (err) {}
    if (!slug) {
      const match = window.location.pathname.match(/\/t\/([^/?#]+)/);
      if (match) {
        try {
          slug = decodeURIComponent(match[1]);
        } catch (err) {
          slug = match[1];
        }
      }
    }
    if (!slug) return null;
    const plainSlug = String(slug).replace(/^\d+-/, '');
    return app.store.all("tags").find(function (tag) {
      if (!tag || typeof tag.slug !== "function") return false;
      const tagSlug = String(tag.slug());
      const tagId = typeof tag.id === "function" ? String(tag.id()) : "";
      return tagSlug === slug || tagSlug === plainSlug || tagId === String(slug);
    }) || null;
  };

  /*
   * VAL : pas de création directe depuis les tags parents.
   * Les discussions doivent être créées dans un tag feuille.
   */
  const valHideNewDiscussionForParentTags = function () {
    const tag = valCurrentTag();
    if (!tag) {
      return;
    }
    const hide = function () {
      const button = document.querySelector(".IndexPage-nav .item-newDiscussion");
      if (button) {
        button.style.display = "none";
      }
    };
    let children = [];
    if (typeof tag.children === "function") {
      try {
        children = tag.children() || [];
      } catch (err) {}
    }
    if (children.length > 0) {
      hide();
      return;
    }
    valEnsureChildTags(tag);
  };
  const valIsWelcomeParent = function (tag) {
    return !!(tag && typeof tag.id === "function" && String(tag.id()) === VAL_WELCOME_PARENT_TAG_ID);
  };

  /*
   * Flarum ne précharge pas nécessairement tous les sous-tags.
   * On force donc, une seule fois par parent, le rechargement du tag
   * courant avec sa relation children.
   */
  const valChildForumsLoaded = new Set();
  const valChildForumsLoading = new Set();
  const valEnsureChildTags = function (parentTag) {
    if (!parentTag || !app.store || typeof app.store.find !== "function" || typeof parentTag.id !== "function") {
      return;
    }
    const id = String(parentTag.id());
    if (!id || valChildForumsLoaded.has(id) || valChildForumsLoading.has(id)) {
      return;
    }
    valChildForumsLoading.add(id);
    app.store.find("tags", id, {
      include: "children,lastPostedDiscussion"
    }).then(function () {
      valChildForumsLoading.delete(id);
      valChildForumsLoaded.add(id);
      m.redraw();
      valScheduleChildForums();
    }).catch(function () {
      valChildForumsLoading.delete(id);
      valChildForumsLoaded.add(id);
      m.redraw();
    });
  };
  const valUnreadChildTags = new Set();
  let valUnreadChildTagsKey = "";
  let valUnreadChildTagsLoadingKey = "";
  const valLoadUnreadChildTags = function (children) {
    const key = children.map(function (tag) {
      return typeof tag.id === "function" ? String(tag.id()) : "";
    }).filter(Boolean).join(",");
    if (!key) {
      valUnreadChildTags.clear();
      valUnreadChildTagsKey = "";
      valUnreadChildTagsLoadingKey = "";
      return Promise.resolve();
    }
    if (key === valUnreadChildTagsKey || key === valUnreadChildTagsLoadingKey) {
      return Promise.resolve();
    }
    valUnreadChildTagsLoadingKey = key;
    valUnreadChildTags.clear();
    const requests = children.map(function (tag) {
      const id = typeof tag.id === "function" ? String(tag.id()) : null;
      const slug = typeof tag.slug === "function" ? tag.slug() : null;
      if (!id || !slug) {
        return Promise.resolve();
      }
      return app.store.find("discussions", {
        filter: {
          tag: slug,
          unread: true
        },
        page: {
          limit: 1
        }
      }).then(function (result) {
        console.log("VAL unread test", id, slug, result);
        if (result && result.length) {
          valUnreadChildTags.add(id);
        }
      }).catch(function (e) {
        console.log("VAL unread error", id, slug, e);
      });
    });
    return Promise.all(requests).then(function () {
      valUnreadChildTagsKey = key;
      valUnreadChildTagsLoadingKey = "";
      m.redraw();
      valScheduleChildForums();
    });
  };
  const valTreeVirtualTag = function (row, parentTag) {
    return {
      __valTreeOnly: row.can_access === false,
      id: function () {
        return String(row.id);
      },
      name: function () {
        return String(row.name || "");
      },
      slug: function () {
        return String(row.slug || "");
      },
      description: function () {
        return String(row.description || "");
      },
      color: function () {
        return row.color || null;
      },
      icon: function () {
        return row.icon || null;
      },
      position: function () {
        return row.position;
      },
      parent: function () {
        return parentTag;
      }
    };
  };
  const valChildTags = function (parentTag) {
    if (!parentTag) return [];
    valLoadTreeTags(parentTag);
    let children = [];
    try {
      const related = parentTag.children && parentTag.children();
      if (Array.isArray(related)) {
        children = related.filter(Boolean);
      }
    } catch (err) {}
    if (!children.length && app.store && typeof app.store.all === "function") {
      children = app.store.all("tags").filter(function (tag) {
        if (!tag || tag === parentTag || typeof tag.parent !== "function") {
          return false;
        }
        try {
          const parent = tag.parent();
          return !!(parent && typeof parent.id === "function" && typeof parentTag.id === "function" && parent.id() === parentTag.id());
        } catch (err) {
          return false;
        }
      });
    }
    if (typeof parentTag.id === "function" && valTreeTagsLoaded.has(String(parentTag.id()))) {
      const parentId = String(parentTag.id());
      const rows = valTreeTagsByParent.get(parentId) || [];
      const knownIds = new Set(children.map(function (tag) {
        return typeof tag.id === "function" ? String(tag.id()) : "";
      }));
      rows.forEach(function (row) {
        const id = String(row.id);
        if (!knownIds.has(id)) {
          children.push(valTreeVirtualTag(row, parentTag));
          knownIds.add(id);
        }
      });
    }
    return children.sort(function (a, b) {
      const pa = typeof a.position === "function" ? a.position() : 0;
      const pb = typeof b.position === "function" ? b.position() : 0;
      return (pa ?? 0) - (pb ?? 0);
    });
  };
  const valTagHref = function (tag) {
    try {
      if (typeof app.route === "function") {
        return app.route("tag", {
          tags: tag.slug()
        });
      }
    } catch (err) {}
    return "/t/" + encodeURIComponent(tag.slug());
  };
  let valWelcomeDiscussion = null;
  let valWelcomeLoading = false;
  let valWelcomeLoaded = false;
  const valEnsureWelcomeDiscussion = function () {
    if (valWelcomeLoaded || valWelcomeLoading || !app.store || typeof app.store.find !== "function") {
      return;
    }
    valWelcomeLoading = true;
    app.store.find("discussions", VAL_WELCOME_DISCUSSION_ID, {
      include: "firstPost"
    }).then(function (discussion) {
      valWelcomeDiscussion = discussion || null;
      valWelcomeLoading = false;
      valWelcomeLoaded = true;
      m.redraw();
      valScheduleChildForums();
    }).catch(function () {
      valWelcomeLoading = false;
      valWelcomeLoaded = true;
      m.redraw();
      valScheduleChildForums();
    });
  };
  const valWelcomePost = function () {
    if (!valWelcomeDiscussion) return null;
    try {
      if (typeof valWelcomeDiscussion.firstPost === "function") {
        const firstPost = valWelcomeDiscussion.firstPost();
        if (firstPost) return firstPost;
      }
    } catch (err) {}
    try {
      if (typeof valWelcomeDiscussion.posts === "function") {
        const posts = valWelcomeDiscussion.posts();
        if (Array.isArray(posts) && posts.length) {
          return posts.filter(Boolean).sort(function (a, b) {
            const na = typeof a.number === "function" ? a.number() : 0;
            const nb = typeof b.number === "function" ? b.number() : 0;
            return (na ?? 0) - (nb ?? 0);
          })[0] || null;
        }
      }
    } catch (err) {}
    return null;
  };
  const valWelcomeContentHtml = function () {
    const post = valWelcomePost();
    if (!post) return "";
    try {
      if (typeof post.contentHtml === "function") {
        return post.contentHtml() || "";
      }
    } catch (err) {}
    return "";
  };
  const valWelcomeTitle = function () {
    if (!valWelcomeDiscussion) {
      return "Bienvenue sur vintage-audio-laser";
    }
    try {
      if (typeof valWelcomeDiscussion.title === "function") {
        return valWelcomeDiscussion.title() || "Bienvenue sur vintage-audio-laser";
      }
    } catch (err) {}
    return "Bienvenue sur vintage-audio-laser";
  };
  const valDiscussionHref = function () {
    if (valWelcomeDiscussion) {
      try {
        if (typeof app.route === "function") {
          return app.route("discussion", {
            id: valWelcomeDiscussion.id(),
            slug: typeof valWelcomeDiscussion.slug === "function" ? valWelcomeDiscussion.slug() : undefined
          });
        }
      } catch (err) {}
    }
    return "/d/" + VAL_WELCOME_DISCUSSION_ID;
  };
  const valEnsureStyles = function () {
    if (document.getElementById("val-child-forums-special-style")) return;
    const style = document.createElement("style");
    style.id = "val-child-forums-special-style";
    style.textContent = `
            .val-parent-welcome {
                margin: 0 0 20px;
                padding: 18px 20px 20px;
                border: 1px solid color-mix(in srgb, var(--muted-color) 24%, transparent);
                border-radius: 8px;
                background: transparent;
            }

            .val-parent-welcome-title {
                margin: 0 0 12px;
                font-size: 20px;
                font-weight: 600;
                line-height: 1.3;
            }

            .val-parent-welcome-title a {
                color: var(--text-color);
                text-decoration: none;
            }

            .val-parent-welcome-title a:hover {
                text-decoration: underline;
            }

            .val-parent-welcome .Post-body {
                margin: 0;
            }

            .val-parent-welcome-loading,
            .val-parent-welcome-error {
                color: var(--muted-color);
                font-size: 13px;
            }



            .val-parent-forums-title {
                margin-top: 0;
            }

            @media (max-width: 767.98px) {
                .val-parent-welcome {
                    padding: 14px 15px 16px;
                    margin-bottom: 16px;
                }

                .val-parent-welcome-title {
                    font-size: 18px;
                }
            }
        `;
    document.head.appendChild(style);
  };
  const valRestoreNativeState = function () {
    document.querySelectorAll("[data-val-empty-hidden='1']").forEach(function (node) {
      node.style.display = "";
      delete node.dataset.valEmptyHidden;
    });
    document.querySelectorAll("[data-val-native-hidden='1']").forEach(function (node) {
      node.style.display = "";
      delete node.dataset.valNativeHidden;
    });
    const oldMount = document.querySelector(".val-child-forums-mount");
    if (oldMount) {
      m.render(oldMount, null);
      oldMount.remove();
    }
  };
  const valRenderForumCards = function (parentTag, children, specialView) {
    const title = specialView ? "Sous-forums" : typeof parentTag.name === "function" ? parentTag.name() : "Sous-forums";
    const parentIcon = parentTag && typeof parentTag.icon === "function" ? parentTag.icon() : null;
    const parentColor = parentTag && typeof parentTag.color === "function" ? parentTag.color() : null;
    return m("section", {
      className: "val-child-forums",
      "aria-label": title
    }, [m("h2", {
      className: specialView ? "val-child-forums-title val-parent-forums-title" : "val-child-forums-title"
    }, title), m("div", {
      className: "val-child-forums-grid"
    }, children.map(function (tag) {
      const name = typeof tag.name === "function" ? tag.name() : "Sous-forum";
      const description = typeof tag.description === "function" ? tag.description() : "";
      const childColor = typeof tag.color === "function" ? tag.color() : null;
      const childIcon = typeof tag.icon === "function" ? tag.icon() : null;
      const effectiveColor = childColor || parentColor || null;
      const effectiveIcon = childIcon || parentIcon || null;
      const isUnread = valUnreadChildTags.has(String(tag.id()));
      return m("a", {
        key: typeof tag.id === "function" ? tag.id() : name,
        className: "val-child-forum-card" + (isUnread ? " val-child-forum-unread" : ""),
        href: tag.__valTreeOnly ? "/acces-reserve" : valTagHref(tag),
        style: effectiveColor ? {
          "--val-child-color": effectiveColor
        } : {}
      }, [m("span", {
        className: "val-child-forum-name"
      }, [effectiveIcon ? m("i", {
        className: effectiveIcon + " val-child-forum-parent-icon",
        "aria-hidden": "true",
        style: {
          color: effectiveColor || "currentColor",
          marginRight: "7px"
        }
      }) : null, name]), description ? m("span", {
        className: "val-child-forum-description"
      }, description) : null, m("span", {
        className: "val-child-forum-arrow",
        "aria-hidden": "true"
      }, "›")]);
    }))]);
  };
  const valWelcomeView = function (parentTag, children) {
    const html = valWelcomeContentHtml();
    const welcomeBlock = m("section", {
      className: "val-parent-welcome",
      "aria-label": "Bienvenue"
    }, [m("h2", {
      className: "val-parent-welcome-title"
    }, m("a", {
      href: valDiscussionHref()
    }, valWelcomeTitle())), html ? m("div", {
      className: "Post-body"
    }, m.trust(html)) : valWelcomeLoaded ? m("div", {
      className: "val-parent-welcome-error"
    }, "Le message de bienvenue n’a pas pu être chargé.") : m("div", {
      className: "val-parent-welcome-loading"
    }, "Chargement du message de bienvenue…")]);
    return m("div", {
      className: "val-parent-home"
    }, [welcomeBlock, valRenderForumCards(parentTag, children, true)]);
  };

  /*
   * Le rendu spécial du parent #4 doit passer par le composant Flarum
   * lui-même. L'ancien montage DOM fonctionnait sur la vue desktop, mais
   * dépendait de la structure HTML de DiscussionList et pouvait être
   * court-circuité par la vue mobile. En remplaçant uniquement la vue de
   * DiscussionList pour ce tag précis, le même contenu est rendu quel que
   * soit le breakpoint. Le montage DOM historique reste plus bas comme
   * filet de sécurité.
   */
  override(DiscussionList.prototype, "view", function (original) {
    const parentTag = valCurrentTag();
    let searchActive = false;
    try {
      searchActive = !!m.route.param("q");
    } catch (err) {}
    if (!parentTag || searchActive || !valIsWelcomeParent(parentTag)) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return original(...args);
    }
    valEnsureStyles();
    valEnsureChildTags(parentTag);
    valEnsureWelcomeDiscussion();
    return m("div", {
      className: "DiscussionList val-welcome-discussion-list",
      "data-val-welcome-list": "1"
    }, valWelcomeView(parentTag, valChildTags(parentTag)));
  });
  const valRenderWelcomeParent = function (parentTag, children) {
    valEnsureStyles();
    valEnsureWelcomeDiscussion();
    const discussionList = document.querySelector(".DiscussionList");
    if (!discussionList || !children.length) {
      valRestoreNativeState();
      return;
    }
    document.querySelectorAll(".DiscussionList-discussions, .DiscussionList-loadMore").forEach(function (node) {
      node.style.display = "none";
      node.dataset.valNativeHidden = "1";
    });
    let mount = document.querySelector(".val-child-forums-mount");
    if (!mount) {
      mount = document.createElement("div");
      mount.className = "val-child-forums-mount";
      discussionList.insertBefore(mount, discussionList.firstChild);
    }
    m.render(mount, valWelcomeView(parentTag, children));
  };
  const valRenderChildForums = function () {
    const parentTag = valCurrentTag();
    valEnsureChildTags(parentTag);
    const children = valChildTags(parentTag);
    valLoadUnreadChildTags(children);
    let searchActive = false;
    try {
      searchActive = !!m.route.param("q");
    } catch (err) {}
    if (!parentTag || searchActive) {
      valRestoreNativeState();
      return;
    }
    valEnsureStyles();
    if (valIsWelcomeParent(parentTag)) {
      valEnsureStyles();
      valEnsureWelcomeDiscussion();

      /*
       * Normalement le rendu spécial est déjà fourni par l'override de
       * DiscussionList ci-dessus (desktop + mobile). Si, pour une vue
       * Flarum particulière, DiscussionList n'est pas le composant
       * utilisé, on conserve l'ancien montage DOM comme repli.
       */
      if (document.querySelector(".val-welcome-discussion-list")) {
        return;
      }
      valRenderWelcomeParent(parentTag, children);
      return;
    }
    if (!children.length) {
      valRestoreNativeState();
      return;
    }
    const discussionList = document.querySelector(".DiscussionList");
    if (!discussionList) {
      valRestoreNativeState();
      return;
    }

    /*
     * Un parent ayant des sous-forums sert ici de conteneur.
     * Depuis que les discussions portent correctement parent + enfant,
     * Flarum ne considère plus le parent comme vide : on masque donc
     * explicitement sa liste native et on conserve la vue en cartes.
     */
    document.querySelectorAll(".DiscussionList-discussions, .DiscussionList-loadMore").forEach(function (node) {
      node.style.display = "none";
      node.dataset.valNativeHidden = "1";
    });
    document.querySelectorAll(".DiscussionList-empty, .DiscussionList .Placeholder").forEach(function (node) {
      node.style.display = "none";
      node.dataset.valEmptyHidden = "1";
    });
    let mount = document.querySelector(".val-child-forums-mount");
    if (!mount) {
      mount = document.createElement("div");
      mount.className = "val-child-forums-mount";
      discussionList.insertBefore(mount, discussionList.firstChild);
    }
    m.render(mount, valRenderForumCards(parentTag, children, false));
  };
  let valChildForumsTimer = null;
  const valScheduleChildForums = function () {
    window.clearTimeout(valChildForumsTimer);
    valChildForumsTimer = window.setTimeout(function () {
      valRenderChildForums();
      valHideNewDiscussionForParentTags();
    }, 40);
  };
  const valChildForumsObserver = new MutationObserver(function () {
    valScheduleChildForums();
  });
  valChildForumsObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  valScheduleChildForums();
});